var exports = {
  "gP": "EmbedVideo.module__videoOverlay___UFFUSG",
  "yH": "EmbedVideo.module__playButtonWrapper___UFFUSG",
  "SK": "EmbedVideo.module__thumbnailPlaceholder___UFFUSG",
  "aO": "EmbedVideo.module__thumbHashPlaceholder___UFFUSG",
  "mZ": "EmbedVideo.module__metadataProbe___UFFUSG",
  "tN": "EmbedVideo.module__blurContainer___UFFUSG",
  "rj": "EmbedVideo.module__blurContent___UFFUSG",
  "UF": "EmbedVideo.module__blurInner___UFFUSG",
  "Y3": "EmbedVideo.module__blurThumbnail___UFFUSG",
  "il": "EmbedVideo.module__mediaContainer___UFFUSG",
  "AA": "EmbedVideo.module__mobileContainer___UFFUSG",
  "SY": "EmbedVideo.module__videoPlayerWrapper___UFFUSG",
  "s": "EmbedVideo.module__videoPlayerBlock___UFFUSG",
  "Qh": "EmbedVideo.module__videoPlayerFill___UFFUSG",
  "hz": "EmbedVideo.module__inlineVideo___UFFUSG",
  "nD": "EmbedVideo.module__inlineMuteButton___UFFUSG",
};

module.exports = exports;
